import { create } from "zustand";
import { persist } from "zustand/middleware";

const formDefault = {
  hazard_override_flag: 0,
  device_usage: 0,
  device_name: "",
  device_code: "",
  device_type: "2", 
};

const store = (set, get) => ({
  form: formDefault,
  visitedTabs: ["hazard"],
  selectedFileNames: [], // ✅ persistable

  setForm: (formValue) => set({ form: formValue }),
  setSelectedFileNames: (files) => set({ selectedFileNames: files }),
  setFormDefault: () => set({ form: formDefault }),
  setVisitedTabs: (tabs) => set({ visitedTabs: tabs }),
});

export const useRiskManagerStore = create(
  persist(store, {
    name: "risk-manager-store",
    version: 1,
    onRehydrateStorage: () => (state, error) => {
      if (error) console.error("Failed to rehydrate", error);
      else console.log("Store rehydrated:", state?.form);
    },
  })
);